// TODO - audit / remove redundant QA + test env + localdev alias for development
export const ENV = ['development', 'localdev', 'qa', 'test', 'staging', 'production'] as const;
export type Env = (typeof ENV)[number];
export const isEnv = (value: string): value is Env => {
  return (ENV as readonly string[]).includes(value);
};

const defineDomains = <T extends Record<Env, string>>(value: T) => value;

const domains = defineDomains({
  production: 'https://www.opendoor.com',
  staging: 'https://demo.simplersell.com',
  qa: 'https://demo.simplersell.com',
  development: 'http://localhost:3011', // cosmos
  localdev: 'http://localhost:3011', // cosmos (alias for development)
  test: 'https://www.opendoor.com',
});

export const getDomain = (env: string): string => {
  if (!isEnv(env) || !domains[env]) {
    throw new Error(`DEVELOPER ERROR: Invalid DOMAIN, env ${env} is not in ${ENV.join(',')}`);
  }
  return domains[env];
};

// Login redirects will not work across domains.
// if cake is configured to use staging, you will be routed
// to the staging login page, but you will not be redirected
// to your local cake instance once you've logged in.
//
// See the 'using a real session with Athena staging'
// section in the README for more information.
const getRedirectUrl = () => encodeURIComponent(window.location.href);

// Name of the query param that stores an email prefill for /login
export const EMAIL_PREFILL_QUERY_PARAM = 'emailPrefill';

// Query params the OAuth redirect flow appends to attribute a failure to the
// login form. Kept here (React-free) so non-component modules can reference the
// names without importing the forms barrel. Source of truth is Rails
// Humans::OmniauthCallbacksController; authError.ts re-exports these.
export const AUTH_ERROR_QUERY_PARAM = 'auth_error';
export const AUTH_ERROR_PROVIDER_QUERY_PARAM = 'auth_error_provider';

/**
 * Returns the URL for normal login. If successfully authenticated, the user will be redirected to the current location.
 *
 * @param env - Environment to use to get the correct domain
 * @param emailPrefill  - [Optional] Email to use to prefill the log-in/sign-up form
 */
export const getLoginUrlWithRedirect = (env: string, emailPrefill?: string) => {
  const emailPrefillParam = emailPrefill ? `&${EMAIL_PREFILL_QUERY_PARAM}=${emailPrefill}` : '';
  return `${getDomain(env)}/login?redirectTo=${getRedirectUrl()}${emailPrefillParam}`;
};

// Login lite query params
export const LOGIN_LITE_ACCESS_TOKEN_QUERY_PARAM = 'access_token';

/**
 * @description
 * Returns the URL for login lite. If successfully authenticated, the user will be redirected to the current location.
 *
 * Domain: `opendoor.com/token`
 * Query params:
 *    1. `access_token=<TOKEN>`
 *    2. `redirect_url=<ENCODED_CURRENT_URL>`
 */
export const getLoginLiteUrlWithRedirect = (env: string, accessToken: string) => {
  return `${getDomain(
    env,
  )}/token?${LOGIN_LITE_ACCESS_TOKEN_QUERY_PARAM}=${accessToken}&redirect_url=${getRedirectUrl()}`;
};
